import * as React from 'react';
import Overlay from 'react-bootstrap/Overlay';
import Tooltip from 'react-bootstrap/Tooltip';
import ErrorBoundary from './ErrorBoundary';

export interface ClipboardIconProps {
    /** Text to copy to clipboard */
    text : string,
    /** Custom classname to append to text */
    className? : string,
    show? : boolean,
    title? : string,
    styles? : Object,
}

const ClipboardIcon: React.FunctionComponent<ClipboardIconProps> = (props: ClipboardIconProps):any => {
    const [show, setShow] = React.useState(false);
    const target:any = React.useRef(null);

    const copyToClipboard = (e: React.SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setShow(true);
        navigator.clipboard.writeText(props.text);
        setTimeout(() => {
            setShow(false);
        }, 800)
    }

    // const tooltipProps = (({ show, ...p }) => p)(props);

    return <ErrorBoundary showError={false} >
        <i 
            title={props.title} 
            onClick={copyToClipboard}
            className={`material-icons cursor-on-hover ${props.className} clipboard-icon`}
            ref={target}
            style={props.styles}
        >
            file_copy
        </i>
        <Overlay target={target.current} show={show} placement="bottom">
            {
                (p:any) => 
                <Tooltip id="session-key-tooltip" {...p} show="true" >
                    Copied To Clipboard
                </Tooltip>
            }
        </Overlay>
    </ErrorBoundary>
}

ClipboardIcon.defaultProps = {
    show : true,
    title : "Copy to Clipboard.",
    className : "",
    styles : {},
}

export default ClipboardIcon;